<template>
  <div class="plannings-page">
    <transition name="fade" appear>
      <v-layout justify-space-between mb-3>
        <h2>Filtrer</h2>
        <v-btn @click="handlePrint">Imprimer le planning</v-btn>
      </v-layout>
    </transition>

    <transition name="fade" appear>
      <v-layout class="filters-container" mb-8 wrap>
        <v-flex sm12>
          <v-layout justify-space-between>
            <v-flex sm4>
              <h3>Par date :</h3>

              <v-dialog v-model="modal_search" width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="filters.date | dateFormat"
                    label="Du"
                    append-icon="mdi-calendar"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  first-day-of-week="1"
                  v-model="filters.date"
                  @change="modal_search = false"
                >
                  <v-layout align-center justify-end pr-4>
                    <v-btn text color="#880e4f" @click="handleCleanDate"
                      >Effacer</v-btn
                    >
                  </v-layout>
                </v-date-picker>
              </v-dialog>
              <v-select
                item-text="value"
                item-value="key"
                :items="date_types"
                label="Type de date"
                filled
                hide-details
                v-model="filters.date_type"
              ></v-select>
            </v-flex>
            <v-divider vertical class="mx-12"></v-divider>
            <v-flex sm4>
              <h3>Par patient :</h3>
              <v-text-field
                outlined
                hide-details
                clearable
                @input="handleLastnameSearch"
                label="Nom"
                class="mt-5"
              ></v-text-field>
              <v-text-field
                outlined
                hide-details
                clearable
                @input="handleFirstnameSearch"
                label="Prénom"
                class="mt-3"
              ></v-text-field>
            </v-flex>
            <v-divider vertical class="mx-12"></v-divider>
            <v-flex sm4>
              <h3>Par statut :</h3>
              <v-layout justify-space-between wrap>
                <v-flex sm6>
                  <v-checkbox
                    class="mt-3"
                    label="Imprimées"
                    v-model="filters.printed"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    class="mt-3"
                    label="Non imprimées"
                    v-model="filters.unprinted"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex sm6>
                  <v-checkbox
                    class="mt-3"
                    label="En commande"
                    v-model="filters.on_order"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    class="mt-3"
                    label="Non affectées"
                    v-model="filters.unaffected"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    class="mt-3"
                    label="Annulées"
                    v-model="filters.canceled"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex sm12 mt-8>
          <v-layout justify-end>
            <!-- <v-btn>Filtrer</v-btn> -->
          </v-layout>
        </v-flex>
      </v-layout>
    </transition>

    <transition name="fade" appear>
      <v-data-table
        :loading="isFetchInProgress"
        loading-text="Chargement des données"
        :headers="headers"
        :items="projects"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :items-per-page="pagination.itemsPerPage"
        :footer-props="{
          itemsPerPageOptions: [10, 100, 1000],
        }"
        group-by="project_group_key"
      >
        <template v-slot:group="{ items, group }">
          <tr>
            <td
              colspan="16"
              class="text-start"
              style="background: rgba(136, 14, 79, 0.5); color: #000 !important"
            >
              {{ getProductMoldelName(items[0].device_label, group) }}
            </td>
          </tr>

          <tr
            v-for="item in items"
            :key="item.uuid"
            :class="{
              'bg-pink': item.idc_emergency_post_op,
              active: item.uuid == selectedRow.uuid,
            }"
            @click="selectedRow = item"
          >
            <!-- Patient name -->
            <td>
              <v-icon
                v-if="userRole !== 'SEWING'"
                @click="
                  $router.push({
                    name: 'ConsultationPage',
                    params: { project_uuid: item.uuid },
                  })
                "
                class="mr-2"
                style="font-size: 20px; color: #841f63"
                >mdi-file</v-icon
              >
              <v-icon
                v-else
                class="mr-2"
                style="font-size: 20px; color: #841f63"
                @click="printProjectAndMedias(item)"
              >
                mdi-printer
              </v-icon>
              <span :class="{ selected: item.selected }">
                {{ item.patient.lastname }} {{ item.patient.firstname }}
              </span>
            </td>

            <!-- Conver quantity -->
            <td>{{ item.cover_quantity }}</td>

            <!-- Applicator name -->
            <td>
              {{ item.applicator.lastname }} {{ item.applicator.firstname }}
            </td>

            <!-- Printed -->
            <td>
              <v-icon v-if="item.idc_printed_sheet">mdi-check</v-icon>
            </td>

            <!-- Strap sewing status -->
            <td>
              <div class @click="handleSewingModal('straps', item)">
                <div
                  v-if="
                    !item.strap_sewing_status ||
                    item.strap_sewing_status === 'NOT_INDICATED'
                  "
                  class="pastille idc_0"
                ></div>
                <div
                  v-if="item.strap_sewing_status == 'SEWING_DONE_FOR_FITTING'"
                  class="pastille idc_1"
                ></div>
                <div
                  v-if="item.strap_sewing_status == 'SEWING_DONE_FOR_FINISHING'"
                  class="pastille idc_2"
                ></div>
                <div
                  v-if="item.strap_sewing_status == 'NO_SEWING_TO_DO'"
                  class="pastille idc_3"
                ></div>
              </div>
            </td>

            <!-- Cover sewing status -->
            <td>
              <div class @click="handleSewingModal('cover', item)">
                <div
                  v-if="
                    !item.cover_sewing_status ||
                    item.cover_sewing_status === 'NOT_INDICATED'
                  "
                  class="pastille idc_0"
                ></div>
                <div
                  v-if="item.cover_sewing_status == 'SEWING_DONE_FOR_FITTING'"
                  class="pastille idc_1"
                ></div>
                <div
                  v-if="item.cover_sewing_status == 'SEWING_DONE_FOR_FINISHING'"
                  class="pastille idc_2"
                ></div>
                <div
                  v-if="item.cover_sewing_status == 'NO_SEWING_TO_DO'"
                  class="pastille idc_3"
                ></div>
              </div>
            </td>

            <!-- Launch test -->
            <td>
              <v-icon v-if="item.idc_launch_test">mdi-check</v-icon>
            </td>

            <!-- Finishing -->
            <td>
              <v-icon v-if="item.idc_finishing">mdi-check</v-icon>
            </td>

            <!-- Not affected -->
            <td>
              <v-icon v-if="item.idc_not_assigned">mdi-check</v-icon>
            </td>

            <!-- On order -->
            <td>
              <v-icon v-if="item.idc_on_order">mdi-check</v-icon>
            </td>

            <!-- Cost calculation date -->
            <td>
              <v-icon v-if="item.cost_calculation_date !== null"
                >mdi-check</v-icon
              >
            </td>

            <!-- Workshop exit for fitting -->
            <td>
              <v-checkbox
                :disabled="userRole == 'SEWING'"
                class="mt-3"
                :input-value="item.idc_workshop_exit_for_fitting"
                @click.prevent.stop="
                  handlePlanningChangeFitting(
                    item.uuid,
                    !item.idc_workshop_exit_for_fitting
                  )
                "
              ></v-checkbox>
            </td>

            <!-- Workshop exit aggregated -->
            <td>{{ getLastWorkshopExitAtDate(item) | dateFormat }}</td>

            <!-- Workshop exit -->
            <td>{{ item.workshop_exit_at | dateFormat }}</td>

            <!-- Delivery at -->
            <td>{{ item.real_delivery_at | dateFormat }}</td>

            <!-- Estimated time -->
            <td>{{ item.estimated_finishing_time }}</td>
          </tr>
        </template>
      </v-data-table>
    </transition>

    <transition name="fade" appear>
      <v-layout justify-space-between mt-12>
        <v-flex sm3>
          <v-textarea
            filled
            name="Commentaires applicateur/secrétariat"
            label="Commentaires applicateur/secrétariat"
            rows="7"
            hide-details
            class="mt-2"
            disabled
            v-model="selectedRow.comment"
          ></v-textarea>
        </v-flex>
        <v-flex sm3>
          <v-textarea
            filled
            name="Commentaires atelier"
            label="Commentaires atelier"
            rows="7"
            hide-details
            class="mt-2"
            disabled
            v-model="selectedRow.workshop_comment"
          ></v-textarea>
        </v-flex>
        <v-flex sm5 pt-4>
          <h3>Légende couture</h3>
          <v-layout align-center mb-3 mt-4>
            <div class="pastille idc_0"></div>
            <p>0 - Non indiqué</p>
          </v-layout>
          <v-layout align-center mb-3>
            <div class="pastille idc_1"></div>
            <p>1 - Couture effectuée pour essayage</p>
          </v-layout>
          <v-layout align-center mb-3>
            <div class="pastille idc_2"></div>
            <p>2 - Couture effectuée pour finition</p>
          </v-layout>
          <v-layout align-center mb-3>
            <div class="pastille idc_3"></div>
            <p>3 - Pas de couture à faire</p>
          </v-layout>
        </v-flex>
      </v-layout>
    </transition>

    <v-dialog v-model="dialog_sewing.modal" max-width="290">
      <v-card>
        <v-card-title class="headline">
          Choisir status couture {{ dialog_sewing.label }} pour
          {{ dialog_sewing.item.patient_fullname }}
        </v-card-title>

        <v-card-text>
          <v-flex>
            <h3>Légende couture</h3>
            <v-layout
              align-center
              @click="handleChangeSewing('NOT_INDICATED')"
              mb-3
              mt-4
            >
              <div class="pastille idc_0"></div>
              <p>0 - Non indiqué</p>
            </v-layout>
            <v-layout
              align-center
              @click="handleChangeSewing('SEWING_DONE_FOR_FITTING')"
              mb-3
            >
              <div class="pastille idc_1"></div>
              <p>1 - Couture effectuée pour essayage</p>
            </v-layout>
            <v-layout
              align-center
              @click="handleChangeSewing('SEWING_DONE_FOR_FINISHING')"
              mb-3
            >
              <div class="pastille idc_2"></div>
              <p>2 - Couture effectuée pour finition</p>
            </v-layout>
            <v-layout
              align-center
              @click="handleChangeSewing('NO_SEWING_TO_DO')"
              mb-3
            >
              <div class="pastille idc_3"></div>
              <p>3 - Pas de couture à faire</p>
            </v-layout>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog_sewing.modal = false"
            >Annuler</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { productsObject } from "@/utils/products";

import { mapGetters } from "vuex";
import utils from "@/mixins/utils";

import { debounce as _debounce } from "lodash";

import PrintRepo from "@/repositories/print";
import ProjectsRepo from "@/repositories/projects";

export default {
  name: "PlanningsPage",

  mixins: [utils],

  data() {
    return {
      isLoading: false,
      isFetchInProgress: true,

      projects: [],

      headers: [
        {
          text: "Nom du patient",
          align: "left",
          value: "patient.lastname",
        },
        {
          text: "Nb de Housses",
          align: "left",
          value: "cover_quantity",
        },
        {
          text: "Nom de l'applicateur",
          align: "left",
          value: "applicator.lastname",
        },
        {
          text: "Imprimé",
          align: "left",
          value: "idc_printed_sheet",
        },
        {
          text: "Couture sangle",
          align: "left",
          value: "strap_sewing_status_real",
        },
        {
          text: "Couture housse",
          align: "left",
          value: "cover_sewing_status_real",
        },
        {
          text: "Validé essayage",
          align: "left",
          value: "idc_launch_test",
        },
        {
          text: "Validé atelier",
          align: "left",
          value: "idc_finishing",
        },
        {
          text: "Non affecté",
          align: "left",
          value: "idc_not_assigned",
        },
        {
          text: "En commande",
          align: "left",
          value: "idc_on_order",
        },
        {
          text: "Finition Atelier",
          align: "left",
          value: "cost_calculation_date",
        },
        {
          text: "Finition Essayage",
          align: "left",
          value: "idc_workshop_exit_for_fitting",
        },
        {
          text: "Sortie d'atelier pour essayage",
          align: "left",
          value: "workshop_exit_at_aggregated",
        },
        {
          text: "Sortie d'atelier pour finition",
          align: "left",
          value: "workshop_exit_at",
        },
        {
          text: "Livré le",
          align: "left",
          value: "real_delivery_at",
        },
        {
          text: " Temps",
          align: "left",
          value: "estimated_finishing_time",
        },
      ],

      totalItems: 0,
      pagination: {
        page: 1,
        itemsPerPage: 100,
      },
      filters: {
        date_type: "created_at",
        date: null,
        printed: null,
        unprinted: null,
        on_order: null,
        unaffected: null,
        canceled: null,
        lastname: null,
        firstname: null,
      },

      selectedRow: {},

      dialog: false,

      tab: null,
      tabs: ["Commentaires applicateur/secretariat", "Commentaires atelier"],
      currentTab: "Commentaires applicateur/secretariat",

      modal_search: false,
      date_type: "MOLDING",
      date_types: [
        {
          key: "CREATE",
          value: "Date creation",
        },
        {
          key: "MOLDING",
          value: "Arrivée de moulage",
        },
        {
          key: "RETURN",
          value: "Retour d'essayage",
        },
        {
          key: "EXIT",
          value: "Sortie d'atelier",
        },
        {
          key: "FITTING",
          value: "Sortie d'atelier Essayage",
        },
        {
          key: "DELIVERY",
          value: "Livraison réelle",
        },
      ],

      sewing_statuses: [
        {
          key: "NOT_INDICATED",
          icon: "idc_0",
          value: "Non indiqué",
        },
        {
          key: "SEWING_DONE_FOR_FITTING",
          icon: "idc_1",
          value: "Couture effectuée pour essayage",
        },
        {
          key: "SEWING_DONE_FOR_FINISHING",
          icon: "idc_2",
          value: "Couture effectuée pour finition",
        },
        {
          key: "NO_SEWING_TO_DO",
          icon: "idc_3",
          value: "Pas de couture à faire",
        },
      ],

      dialog_sewing: {
        modal: false,
        type: "",
        label: "",
        item: "",
      },

      show_sewing_strap: null,
      show_sewing_cover: null,
    };
  },
  computed: {
    ...mapGetters({
      userRole: "user/userRole",
    }),

    // Current tab
    currentTabComponent() {
      return this.currentTab + "Tab";
    },

    currentTabProps() {
      return {
        project: this.project,

        // Settings
        operations: this.operations,
        devices: this.devices,
        brackets: this.brackets,
      };
    },
  },

  watch: {
    // TODO: Better handling of fetch
    pagination: {
      handler() {
        console.log("Pagination changed");
        this.loading = true;
        this.fetchPlanningProjects();
      },
      deep: true,
    },

    filters: {
      handler() {
        this.loading = true;
        console.log("Filters changed");
        this.fetchPlanningProjects();
      },
      deep: true,
    },
  },

  methods: {
    async fetchPlanningProjects() {
      try {
        this.isFetchInProgress = true;
        const { pagination, filters } = this;
        const { data, total } = await this.$store.dispatch(
          "projects/fetchPlanningProjects",
          {
            pagination,
            filters,
          }
        );

        this.projects = data;
        this.totalItems = total;
      } catch (error) {
        console.error(error);
      } finally {
        this.isFetchInProgress = false;
      }
    },

    // Use of lodash debounce funtion.
    // Triggers mutation after user stops writing (500ms)
    // Avoid ti trigger mutation on every key press
    handleLastnameSearch: _debounce(function (lastname) {
      if (lastname !== null && lastname.length >= 3) {
        this.filters.lastname = lastname;
      } else {
        this.filters.lastname = null;
      }
    }, 500),

    // Use of lodash debounce funtion.
    // Triggers mutation after user stops writing (500ms)
    // Avoid ti trigger mutation on every key press
    handleFirstnameSearch: _debounce(function (firstname) {
      if (firstname !== null && firstname.length >= 3) {
        this.filters.firstname = firstname;
      } else {
        this.filters.firstname = null;
      }
    }, 500),

    getLastWorkshopExitAtDate(item) {
      let date = null;

      if (item.workshop_exit3_at) {
        date = item.workshop_exit3_at;
      } else if (item.workshop_exit2_at) {
        date = item.workshop_exit2_at;
      } else if (item.workshop_exit1_at) {
        date = item.workshop_exit1_at;
      }
      return date;
    },

    getProductMoldelName(device_label, model) {
      if (device_label) {
        return device_label;
      }

      return `Non defini (${productsObject[model].name})`;
    },

    handleCleanDate() {
      this.filters.date = null;
      this.modal_search = false;
    },

    async handlePlanningChangeFinishing(uuid, value) {
      try {
        await ProjectsRepo.updateProjectPlanning(uuid, {
          idc_finishing: value,
        });
      } catch (error) {
        console.error(error);
      }
      this.fetchPlanningProjects();
    },

    // Update workshop_exit_for_fitting
    async handlePlanningChangeFitting(uuid, value) {
      try {
        await ProjectsRepo.updateProjectPlanning(uuid, {
          idc_workshop_exit_for_fitting: !!value,
        });
        await this.fetchPlanningProjects();
      } catch (error) {
        console.error(error);
      }
    },

    async handlePlanningChangeSewingStrap(ev, row) {
      try {
        await ProjectsRepo.updateProjectPlanning(row.uuid, {});
      } catch (error) {
        console.error(error);
      }
      this.fetchPlanningProjects();
    },

    async handlePlanningChangeSewingStrapCover(ev, row) {
      try {
        await ProjectsRepo.updateProjectPlanning(row.uuid, {});
      } catch (error) {
        console.error(error);
      }
      this.fetchPlanningProjects();
    },

    // Print project and medias
    async handlePrint() {
      var search_params = {
        idc_printed_sheet: this.filters.printed ? true : undefined,
        idc_not_printed_sheet: this.filters.unprinted ? true : undefined,
        idc_canceled: this.filters.canceled ? true : undefined,
        idc_not_assigned: this.filters.unaffected ? true : undefined,
        idc_on_order: this.filters.on_order ? true : undefined,

        patient_firstname: this.filters.firstname
          ? this.filters.firstname.toLowerCase()
          : undefined,
        patient_lastname: this.filters.lastname
          ? this.filters.lastname.toLowerCase()
          : undefined,
      };

      if (this.filters.date) {
        search_params.date = this.filters.date;
        search_params.date_type = this.filters.date_type;
      }

      try {
        const res = await PrintRepo.getPlanning(search_params);
        let blob = new Blob([res], {
          type: "application/pdf",
        });

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = "planning.pdf";
        link.click();
      } catch (error) {
        console.error(error);
      }
    },

    // Download project (+ medias) pdf
    async printProjectAndMedias(item) {
      try {
        this.isLoading = true;

        // Get PDF data and create a blob for download capabilities
        const res = await PrintRepo.getProjectAndMedias(item.uuid);
        let blob = new Blob([res], { type: "application/pdf" });

        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${item.patient.lastname}_${item.patient.firstname}.pdf`;
        link.click();

        this.$notify("Téléchargement réussi");
      } catch (error) {
        this.$notify({
          type: "error",
          text: "Une erreur est survenue",
        });

        // Response status is not in the range of 2xx
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else {
          console.log(error, error.message);
        }
      } finally {
        this.isLoading = false;
      }
    },

    handleSewingModal(stype, item) {
      if (this.userRole !== "SEWING") {
        return;
      }

      this.dialog_sewing.type = stype;
      this.dialog_sewing.label = stype == "straps" ? "sangles" : "housse";
      this.dialog_sewing.item = item;
      this.dialog_sewing.modal = true;
    },

    async handleChangeSewing(status) {
      var payload = {};

      try {
        if (this.dialog_sewing.type == "straps") {
          payload.strap_sewing_status = status;
        } else {
          payload.cover_sewing_status = status;
        }
        await ProjectsRepo.updateProjectPlanning(
          this.dialog_sewing.item.uuid,
          payload
        );
      } catch (error) {
        console.error(error);
      }
      this.dialog_sewing.modal = false;
      this.fetchPlanningProjects();
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.5s ease;
}

.fade-enter-to {
  opacity: 1;
}

.plannings-page {
  h2 {
    font-size: 25px !important;
    text-transform: uppercase;
  }
  .v-btn {
    background-color: #006064 !important;
    color: white;
  }
  .filters-container {
    background-color: #f0f0f0;
    padding: 30px;
  }
  .v-data-table {
    table {
      tr {
        background-color: white !important;

        &.active {
          background-color: #bdc3c7 !important;
        }

        &.bg-pink {
          background-color: #ff9696 !important;
        }

        &.v-row-group__header {
          background-color: rgba(132, 31, 99, 0.05) !important;
          .v-btn {
            display: none;
          }
        }
        &:not(.v-row-group__header) {
          td,
          th {
            &:not(:last-child) {
              border-right: 1px solid #707070;
            }
          }
        }
      }
    }
  }

  .selected {
    color: red !important;
  }
}

.pastille {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  border: 1px solid transparent;
  margin-right: 15px;
  &.idc_0 {
    border-color: #707070;
    background-color: white;
  }
  &.idc_1 {
    border-color: #63a566 !important;
    background-color: #63a566;
  }
  &.idc_2 {
    background-color: #e00000;
    border-color: #e00000 !important;
  }
  &.idc_3 {
    border-color: black !important;
    background-color: black;
  }
  & ~ p {
    margin: 0;
  }
}
</style>
